import { render, staticRenderFns } from "./iristarProduct.vue?vue&type=template&id=64ced2e6&"
import script from "./iristarProduct.vue?vue&type=script&lang=js&"
export * from "./iristarProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports